import { cn } from "@/lib/cn";

interface UnsavedPillProps {
  nextVersion: number;
  visible: boolean;
}

export function UnsavedPill({ nextVersion, visible }: UnsavedPillProps) {
  if (!visible) {
    return null;
  }

  return (
    <div
      className={cn(
        "inline-flex items-center gap-2",
        "px-3 py-1.5 rounded-full",
        "border border-[#E0A458]",
        "bg-[#FBF1DD]",
        "text-[#8A5A1F] text-sm font-medium",
      )}
    >
      <span className="size-2 rounded-full bg-[#E0A458] animate-pulse" />
      <span>Unsaved · live → v{nextVersion}</span>
    </div>
  );
}
